import rasterizeHTML from 'rasterizehtml';

import EDBox from '../../../BaseComponents/EDBox/EDBox';
import EDIcon from '../../../BaseComponents/Icon/EDIcon';
import EDMenuItem from '../../../BaseComponents/Menu/EDMenuItem';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';
import { getHourMin } from '../../../Utils/dateUtils';
import { getServerURL } from '../../../Utils/getServerURL';

interface IProps {
  contextMenuID: string;
  displayMenuClass: string;
  imageIndex: number;
  imageSrc: string;
  isSveFaktura: boolean;
  verifikationsNr: string | undefined;
}

export const downloadImage = async (
  imageSrc: string,
  fileName: string,
  skannadSvefaktura: boolean
) => {
  const image = await fetch(imageSrc, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors',
  });

  if (skannadSvefaktura) {
    const fakturabild = document.querySelector('#Fakturabild');

    if (!fakturabild) {
      return;
    }
    fakturabild.setAttribute(
      'style',
      'aspect-ratio:1/1.41;height:100%;width:100%;'
    );

    const link = document.createElement('a');
    const canvas = document.createElement('CANVAS') as HTMLCanvasElement;

    // Tre gånger pixel värderna för en A4
    canvas.width = 595 * 3;
    canvas.height = 842 * 3;

    rasterizeHTML
      .drawHTML(fakturabild.parentElement?.innerHTML ?? '', canvas, {
        baseUrl: getServerURL(),
        zoom: 1,
      })
      .then(() => {
        canvas.toBlob(blob => {
          if (blob) {
            const imageURL = URL.createObjectURL(blob);

            link.href = imageURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }, 'image/jpeg');
      });

    fakturabild.removeAttribute('style');
  } else {
    const imageBlob = await image.blob();
    const imageURL = URL.createObjectURL(imageBlob);

    const link = document.createElement('a');
    link.href = imageURL;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const DownloadContextMenu: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDBox
      id={props.contextMenuID}
      sx={{
        display: 'none',
        position: 'absolute',
        zIndex: 999999,
        top: 0,
        left: 0,
        background: theme => theme.palette.background.paper,
        border: theme => `1px solid ${theme.palette.grey[400]}`,
        boxShadow: '0px 2px 3px -1px rgba(0,0,0,0.5)',
        paddingY: 0.5,
        borderRadius: 1,
      }}
    >
      <EDMenuItem
        onClick={() => {
          const today = new Date();
          const hoursAndMinutes = getHourMin(today);

          const fileName =
            (props.imageIndex > 0
              ? `fakturabild_${props.imageIndex + 1}_`
              : 'fakturabild_') +
            (props.verifikationsNr ?? 0) +
            ' ' +
            today.toLocaleDateString('sv-SE') +
            ' ' +
            hoursAndMinutes[0] +
            ':' +
            hoursAndMinutes[1];

          downloadImage(props.imageSrc, fileName, props.isSveFaktura);

          const customContextMenu =
            document.querySelector('#customContextMenu');

          if (customContextMenu) {
            customContextMenu.classList.remove(props.displayMenuClass);
            customContextMenu.setAttribute('style', '');
          }
        }}
      >
        <EDIcon iconType="download" color="secondary" marginRight={1} />
        <EDTypography>Ladda ner fakturabild</EDTypography>
      </EDMenuItem>
    </EDBox>
  );
};

export default DownloadContextMenu;
